import { isServer } from './isServer';

export const inAppBrowserNameRegex =
  /naver|kakaotalk|line|snapchat|instagram|whatsapp|kakaostory|band|twitter|DaumApps|DaumDevice\/mobile|Works|FB_IAB|FB4A|FBAN|FBAV|FBIOS|FBSS|tiktok|musical_ly|bytedance|bytenews|trill/i;

export type InAppBrowserName =
  | 'naver'
  | 'kakaotalk'
  | 'line'
  | 'snapchat'
  | 'instagram'
  | 'whatsapp'
  | 'kakaostory'
  | 'band'
  | 'twitter'
  | 'daum'
  | 'works'
  | 'facebook'
  | 'tiktok'
  | 'unknown';

const inAppBrowserMatchers: Array<{
  name: InAppBrowserName;
  regex: RegExp;
}> = [
  { name: 'facebook', regex: /FB_IAB|FB4A|FBAN|FBAV|FBIOS|FBSS/i },
  { name: 'tiktok', regex: /tiktok|musical_ly|bytedance|bytenews|trill/i },
  { name: 'instagram', regex: /instagram/i },
  { name: 'kakaotalk', regex: /kakaotalk/i },
  { name: 'line', regex: /line/i },
  { name: 'naver', regex: /naver/i },
  { name: 'snapchat', regex: /snapchat/i },
  { name: 'whatsapp', regex: /whatsapp/i },
  { name: 'kakaostory', regex: /kakaostory/i },
  { name: 'band', regex: /band/i },
  { name: 'twitter', regex: /twitter/i },
  { name: 'daum', regex: /DaumApps|DaumDevice\/mobile/i },
  { name: 'works', regex: /Works/i },
];

export const isInAppBrowserUserAgent = (
  userAgent: string,
  regex = inAppBrowserNameRegex,
): boolean => regex.test(userAgent);

export const getInAppBrowserNameFromUserAgent = (
  userAgent: string,
): InAppBrowserName => {
  const matcher = inAppBrowserMatchers.find(({ regex }) =>
    regex.test(userAgent),
  );

  return matcher?.name ?? 'unknown';
};

export const isInAppBrowser = (regex = inAppBrowserNameRegex) => {
  if (isServer()) {
    return false;
  }
  return isInAppBrowserUserAgent(window.navigator.userAgent, regex);
};

export const getInAppBrowserName = (): InAppBrowserName => {
  if (isServer()) {
    return 'unknown';
  }

  return getInAppBrowserNameFromUserAgent(window.navigator.userAgent);
};
